import gql from 'graphql-tag'

const UpdateRefundToPax = gql`
  mutation UpdateRefundToPax ($input: UpdateRefundToPaxMutationInput!){
    updateRefundToPax (input: $input) {
      claim {
        refundToPaxAmount,
        refundToPaxDate
      }
    }
  }
`

export { UpdateRefundToPax }



// WEBPACK FOOTER //
// ./src/mutations/UpdateRefundToPax.js